import type { SuggestInviteMembersModalAction } from '#actions/suggestInviteMembersModal';
import type { SuggestInviteMembersModalProps } from '#components/inviteMembers/SuggestInviteMembersModal';
import registry from '#reducers/registry';
import type { GlobalState } from '#reducers/state';

type SuggestInviteMembersModalState = {
  showModal: boolean;
  props: SuggestInviteMembersModalProps;
};

export const initialState: SuggestInviteMembersModalState = {
  showModal: false,
  props: {},
};

export function suggestInviteMembersModal(
  state: SuggestInviteMembersModalState = initialState,
  action: SuggestInviteMembersModalAction,
) {
  switch (action.type) {
    case 'suggestInviteMembersModal/OPEN_MODAL':
      return { ...state, showModal: true, props: action.props };
    case 'suggestInviteMembersModal/CLOSE_MODAL':
      return { ...state, showModal: false, props: {} };
    default:
      return state;
  }
}

export const suggestInviteMembersModalSelector = (state: GlobalState) => state.suggestInviteMembersModal;

registry.addReducers({ suggestInviteMembersModal });

declare module '#reducers/state' {
  interface GlobalState {
    suggestInviteMembersModal: ReturnType<typeof suggestInviteMembersModal>;
  }
}
